import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  standalone: false,
  // tslint:disable-next-line: directive-selector
  selector: '[numeric]'
})
export class NumericDirective {
  @Input() numericType: string; // number | decimal

  private regex = {
    number: new RegExp(/^\d+$/),
    decimal: new RegExp(/^\d{0,3}(\.\d{1,2})?$/)
  };

  private specialKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', '.'];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex[this.numericType])) {
      event.preventDefault();
    }
  }
}
